import { Typography } from "@mui/material";
import React from "react";
function toRoman(num) {
  const romanMap = {
    1: "I",
    2: "II",
    3: "III",
    4: "IV",
    5: "V",
    6: "VI",
    7: "VII",
    8: "VIII",
    9: "IX",
    10: "X",
    11: "XI",
    12: "XII",
    13: "XIII",
    14: "XIV",
    15: "XV",
  };

  return romanMap[num] || "Invalid number";
}
function BrsrView({ answerResponse, questionsData, classes }) {
  const questionDict = {};
  const subQuestionDict = {};

  // Process questionsData to create the structure
  questionsData?.forEach(
    ({ main_section, section, question, id, question_id }) => {
      if (!questionDict[main_section]) questionDict[main_section] = {};
      if (!questionDict[main_section][section])
        questionDict[main_section][section] = [];

      if (question_id !== "None") {
        if (!subQuestionDict[question_id]) subQuestionDict[question_id] = [];
        subQuestionDict[question_id].push({ question, id });
      }

      questionDict[main_section][section].push({ question, id, question_id });
    }
  );

  const getAnswer = (questionId) => {
    const answer = answerResponse?.answer?.find(
      (a) => a.question_id === questionId
    )?.answer;
    return answer || "";
  };

  return (
    <div className={classes.questionList}>
      {Object.keys(questionDict).map((mainSection) => (
        <React.Fragment key={mainSection}>
          <div className={classes.scoreDiv}>
            <Typography variant="h3" className={classes.sectionHeader}>
              {mainSection.toUpperCase()}
            </Typography>
          </div>

          {Object.keys(questionDict[mainSection]).map(
            (subSection, subIndex) => (
              <div key={subSection}>
                <Typography variant="h4" className={classes.subSectionHeader}>
                  {`${toRoman(subIndex + 1)}. ${subSection}`}
                </Typography>

                {questionDict[mainSection][subSection].map((question) => {
                  const answer = getAnswer(question.id);
                  if (!answer) return null;

                  return (
                    <div key={question.id} className={classes.questionItem}>
                      <Typography
                        variant="body1"
                        className={classes.questionText}
                      >
                        {question.question}
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.answerText}
                      >
                        {answer}
                      </Typography>

                      {subQuestionDict[question.id]?.map((subQ) => {
                        const subAnswer = getAnswer(subQ.id);
                        return subAnswer ? (
                          <div key={subQ.id} className={classes.subQuestion}>
                            <Typography
                              variant="body2"
                              className={classes.subQuestionText}
                            >
                              {subQ.question}
                            </Typography>
                            <Typography
                              variant="body2"
                              className={classes.subAnswerText}
                            >
                              {subAnswer}
                            </Typography>
                          </div>
                        ) : null;
                      })}
                    </div>
                  );
                })}
              </div>
            )
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default BrsrView;
